import { isEmpty } from 'lodash'
import { FETCH_PHONE_FAIL, FETCH_PHONE_SUCCESS, FETCH_PHONE_LOADING } from '../actions/types'

const INITIAL_STATE = {
  loading: true,
  fail: false,
  data: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_PHONE_SUCCESS:
      const data = isEmpty(action.payload) ? null : action.payload[0]
      return { fail: false, loading: false, data }

    case FETCH_PHONE_LOADING:
      return { fail: false, loading: true, data: null }

    case FETCH_PHONE_FAIL:
      return { fail: true, loading: false, data: null }

    default:
      return state
  }
}
